import { render, staticRenderFns } from "./PlanHistory.vue?vue&type=template&id=3cfb4c1c"
import script from "./PlanHistory.vue?vue&type=script&lang=js"
export * from "./PlanHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports